import * as types from '../actions/action-types';

const getInitialState = () => ({
  validationMessage: null,
});

const editBasketReducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case types.SET_EDIT_BASKET_VALIDATION_MESSAGE:
      return {
        ...state,
        validationMessage: action.message,
      };
    default:
      return state;
  }
};

export default editBasketReducer;